export default function about_us() {
    const b = "background:linear-gradient(to bottom right,#212349,#2f459d,#6486c7,#a1aec9);";
    const c = b + 'color:#fff;font-size:16px;font-family:sans-serif;font-size: 12px;border-radius: 8px; padding: 4px; box-shadow:aliceblue 0 20px;border:#6486c7 solid 1px;font-weight:bold';
    console.log('%cNon, le grand amour ne suffit pas.\n' +
        'Seul un adieu fleurira.\n' +
        'C\'est notre histoire de vie, douce et amère.\n' +
        '⌜La vaguelette⌟ ', b + 'color:#0000;background:linear-gradient(to bottom right,#6486c7,#a1aec9) text;font-size:14px;font-family:sans-serif');
    console.log('%c Sakurairo %c https://github.com/mirai-mamori/Sakurairo', c, '');
}
